/**
 * Deal Flow Redux Constants
 *
 * These constants support the Deal Flow rating and interest tracking system.
 * Used by admin and evaluator roles to rate campaigns and view investor interest.
 */

// Submit Admin/Evaluator Rating
export const ADMIN_SUBMIT_RATING_REQUEST = "ADMIN_SUBMIT_RATING_REQUEST";
export const ADMIN_SUBMIT_RATING_SUCCESS = "ADMIN_SUBMIT_RATING_SUCCESS";
export const ADMIN_SUBMIT_RATING_FAIL = "ADMIN_SUBMIT_RATING_FAIL";

// Get Campaign Ratings (Full Breakdown by Rater Type)
export const ADMIN_GET_RATINGS_REQUEST = "ADMIN_GET_RATINGS_REQUEST";
export const ADMIN_GET_RATINGS_SUCCESS = "ADMIN_GET_RATINGS_SUCCESS";
export const ADMIN_GET_RATINGS_FAIL = "ADMIN_GET_RATINGS_FAIL";

// Get Interest Stats (Favorites, Soft Commitments)
export const ADMIN_GET_INTEREST_STATS_REQUEST = "ADMIN_GET_INTEREST_STATS_REQUEST";
export const ADMIN_GET_INTEREST_STATS_SUCCESS = "ADMIN_GET_INTEREST_STATS_SUCCESS";
export const ADMIN_GET_INTEREST_STATS_FAIL = "ADMIN_GET_INTEREST_STATS_FAIL";

// Recalculate Campaign Stats
export const ADMIN_RECALCULATE_STATS_REQUEST = "ADMIN_RECALCULATE_STATS_REQUEST";
export const ADMIN_RECALCULATE_STATS_SUCCESS = "ADMIN_RECALCULATE_STATS_SUCCESS";
export const ADMIN_RECALCULATE_STATS_FAIL = "ADMIN_RECALCULATE_STATS_FAIL";

// Clear Errors
export const ADMIN_DEAL_FLOW_CLEAR_ERROR = "ADMIN_DEAL_FLOW_CLEAR_ERROR";

// Reset State
export const ADMIN_DEAL_FLOW_RESET = "ADMIN_DEAL_FLOW_RESET";
